import React from "react";

const ServicesCard = ({ sp, icon, title, text, rating, ...props }) => {
    return (
        <div
            {...props}
            className={`${sp} relative block p-8 hover:shadow-md shadow rounded-xl hover:bg-blue-300 dark:hover:bg-lime-500 dark:hover:text-gray-900  dark:shadow-gray-700 dark:bg-gray-800 font-mono font-medium hover:text-gray-900`}
        >
            <span className="absolute right-4 top-4 rounded-full px-3 py-1.5 bg-green-100 text-green-600 font-medium text-xs font-mono dark:hover:bg-gray-900">
                {rating}
            </span>

            <div className="mt-4 sm:pr-0 text-gray-900 hover:text-gray-900">
                {icon}

                <h5 className="mt-4 text-xl text-yellow-600 dark:hover:text-gray-900 font-bold hover:text-gray-900 dark:text-zinc-700 truncate font-mono">
                    {title}
                </h5>

                <p className="hidden mt-2 text-sm sm:block font-mono text-gray-600">{text}</p>
            </div>
        </div>
    );
};

export default ServicesCard;
